import { useField } from 'formik';
import React, { FC } from 'react';
import FormDropFile, { FormDropFileProps } from '..';

export interface FormikFormFileProps extends FormDropFileProps {
    name: string;
    image?: string;
}

const FormikFormFile: FC<FormikFormFileProps> = ({ name, image, ...props }) => {
    const [field, meta, helpers] = useField<File>(name);
    // Render.
    const error = !!(meta.touched && meta.error) ? meta.error : undefined;

    return <FormDropFile error={error} {...props} value={field.value} onClick={() => helpers.setTouched(true, true)} onChange={helpers.setValue} image={image} />;
};

export default FormikFormFile;
